var InputBorderStyle = /* @__PURE__ */ ((InputBorderStyle2) => {
  InputBorderStyle2[InputBorderStyle2["None"] = 0] = "None";
  InputBorderStyle2[InputBorderStyle2["AllSides"] = 1] = "AllSides";
  InputBorderStyle2[InputBorderStyle2["Bottom"] = 2] = "Bottom";
  return InputBorderStyle2;
})(InputBorderStyle || {});
var SubmitButtonStyle = /* @__PURE__ */ ((SubmitButtonStyle2) => {
  SubmitButtonStyle2[SubmitButtonStyle2["Rectangle"] = 0] = "Rectangle";
  SubmitButtonStyle2[SubmitButtonStyle2["RectangleRoundedCorners"] = 1] = "RectangleRoundedCorners";
  SubmitButtonStyle2[SubmitButtonStyle2["RectangleFilled"] = 2] = "RectangleFilled";
  SubmitButtonStyle2[SubmitButtonStyle2["RectangleRoundedCornersFilled"] = 3] = "RectangleRoundedCornersFilled";
  SubmitButtonStyle2[SubmitButtonStyle2["Text"] = 4] = "Text";
  return SubmitButtonStyle2;
})(SubmitButtonStyle || {});
export {
  InputBorderStyle,
  SubmitButtonStyle
};
//# sourceMappingURL=style-params.js.map
